import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !/^\/auth\/(refresh|login|logout)/.test(String(cfg.url))) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function fmtErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return d.msg || String(d);
}

export const imgUrl = (u) => (!u ? "" : u.startsWith("/api") ? `${BACKEND}${u}` : u);

export const STAFF = ["super_admin", "reporter_approver", "news_approver", "editor"];
export const hasRole = (u, ...roles) =>
  !!u && (u.roles.includes("super_admin") || roles.some((r) => u.roles.includes(r)));
export const isDesk = (u) => hasRole(u, ...STAFF, "reporter");

export function fmtDate(iso, lang = "en") {
  if (!iso) return "";
  return new Date(iso).toLocaleString(lang === "ta" ? "ta-IN" : "en-IN", { dateStyle: "medium", timeStyle: "short" });
}

export function timeLeft(iso) {
  if (!iso) return "";
  const ms = new Date(iso) - new Date();
  if (ms <= 0) return "expired";
  const h = Math.floor(ms / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  return h >= 24 ? `${Math.floor(h / 24)}d ${h % 24}h left` : `${h}h ${m}m left`;
}

export const LABELS = {
  breaking: { en: "Breaking News", ta: "முக்கியச் செய்திகள்" },
  hot: { en: "Hot News", ta: "சூடான செய்திகள்" },
  regular: { en: "Latest News", ta: "சமீபத்திய செய்திகள்" },
  readMore: { en: "Read story", ta: "மேலும் படிக்க" },
  comments: { en: "Comments", ta: "கருத்துகள்" },
  related: { en: "More in this section", ta: "இந்தப் பிரிவில் மேலும்" },
  share: { en: "Share on WhatsApp", ta: "வாட்ஸ்அப்பில் பகிர்" },
  reportedBy: { en: "Reported by", ta: "செய்தியாளர்" },
  empty: { en: "No stories here yet.", ta: "இங்கு இன்னும் செய்திகள் இல்லை." },
};
export const L = (key, lang) => LABELS[key]?.[lang] || LABELS[key]?.en || key;

export const hasLang = (s, l) => !!(s?.[l]?.headline || "").trim();
export const pickLang = (s, lang) => {
  const other = lang === "ta" ? "en" : "ta";
  return hasLang(s, lang) || !hasLang(s, other) ? lang : other;
};
export const htmlText = (html) => (html || "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
